import { render, staticRenderFns } from "./StaffStatsTableRow.vue?vue&type=template&id=a035a102&"
import script from "./StaffStatsTableRow.vue?vue&type=script&lang=js&"
export * from "./StaffStatsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports